import { useMemo } from 'react';
import {
  useGetTimelinePostsQuery,
  useCreatePostMutation,
} from '../features/timeline/timelineApiSlice';

function useTimeline({ userid, shopid, businessType, skip = false } = {}) {
  const skipQuery = skip || (!userid && !shopid);

  const { data, isLoading, isError, refetch } = useGetTimelinePostsQuery(
    { userid, shopid, businessType },
    { skip: skipQuery }
  );

  const timelineObj = data?.data?.[0] || null;
  const timelineID = timelineObj?._id;
  const my = timelineObj?.my || [];
  const sharebyother = timelineObj?.sharebyother || [];
  const sharedtoother = timelineObj?.sharedtoother || [];
  const combined = useMemo(() => [...my, ...sharebyother, ...sharedtoother], [my, sharebyother, sharedtoother]);
  // Only block the first load. Using isFetching here replaced posts with
  // skeletons after Share and made shared posts look missing on /user-profile.
  const loading = isLoading && !data;

  const [createPost, createResult] = useCreatePostMutation();

  const createPostSubmit = async (payload) => {
    try {
      // Debug: log payload before sending
      console.debug('[useTimeline] createPost payload:', payload);
      const result = await createPost(payload).unwrap();
      console.debug('[useTimeline] createPost result:', result);
      return result;
    } catch (err) {
      console.error('[useTimeline] createPost error:', err);
      throw err;
    }
  };

  return {
    timelineID,
    my,
    sharebyother,
    sharedtoother,
    combined,
    businessType: timelineObj?.businessType || businessType || null,
    loading,
    isError,
    refetch,
    createPostSubmit,
    createResult,
  };
}

export default useTimeline;
